import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import LinkCell from "./LinkCell";
import LinkReel from "./LinkReel";
export default class LinkReelRotation extends LinkReel {
    constructor(scene, x, y, index, orientation) {
        super(scene, x, y, index, orientation);
        for (let i = 0; i < 1; i++) {
            this.linkCells[i] = new LinkCell(this.scene, this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, i, this);
            this.getContainer().add(this.linkCells[i].getContainer());
        }
    }
    configureSpinTween() {
        this.resetFlagsAndCounters();
        const decelerationTrackTimes = new Map();
        this.spinProgress = this.scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: 1 }, // non serve spostare niente, è un timer
            paused: true,
            loop: 0, // una sola animazione
            yoyo: false,
            duration: ResourcesDispatcher.GAME_CONSTANTS.LINK_SPIN_DURATION, // DURATA TOTALE dello spin (es. 3 secondi)
            onStart: () => {
                // Avvia la rotazione della moneta in TUTTE le celle
                this.linkCells.forEach(linkCell => {
                    linkCell.stopAnimation();
                    linkCell.startCoinSpin();
                });
                this.stopped = false;
                this.canStop = false;
            },
            onUpdate: (tween) => {
                const decelerationDuration = 400;
                const decelerationStart = 1 - decelerationDuration / ResourcesDispatcher.GAME_CONSTANTS.LINK_SPIN_DURATION;
                if (tween.progress < decelerationStart) {
                    return;
                }
                const decelerationProgress = (tween.progress - decelerationStart) / (1 - decelerationStart);
                this.linkCells.forEach(linkCell => {
                    const spine = linkCell.getSpine(linkCell.getMemo());
                    const trackEntry = spine?.animationState.tracks[0];
                    if (trackEntry) {
                        let trackTimes = decelerationTrackTimes.get(linkCell);
                        if (!trackTimes && trackEntry.animation) {
                            const animationDuration = trackEntry.animation.duration;
                            const nextAnimationEnd = (Math.floor(trackEntry.trackTime / animationDuration) + 1) * animationDuration;
                            trackTimes = { from: trackEntry.trackTime, to: nextAnimationEnd };
                            decelerationTrackTimes.set(linkCell, trackTimes);
                        }
                        if (trackTimes) {
                            const easedProgress = Phaser.Math.Easing.Cubic.Out(decelerationProgress);
                            trackEntry.timeScale = 0;
                            trackEntry.trackTime = trackTimes.from + ((trackTimes.to - trackTimes.from) * easedProgress);
                        }
                    }
                });
            },
            onComplete: () => {
                // Qui avviene lo stop delle monete
                if (!this.stopped) {
                    this.stopCoinAnimations();
                }
                // callback del reel completato
                this.scene.linkGameArea.notifySpinCompleted(this.index);
                // stop bottone spin
                if (this.spinMainButtonTween && this.spinMainButtonTween.isPlaying()) {
                    this.spinMainButtonTween.stop();
                    window.isButtonSpinning = false;
                }
            }
        });
    }
    // This check is done for safety. It should NEVER happen that the reels are still spinning when this method is called.
    securityCheckStop() {
        if (this.spinProgress?.isPlaying()) {
            this.spinProgress.stop();
        }
        else if (this.bounceTween1?.isPlaying()) {
            this.bounceTween1.stop();
        }
        else if (this.bounceTween2?.isPlaying()) {
            this.bounceTween2.stop();
        }
    }
    stopCoinAnimations() {
        this.stopped = true;
        this.linkCells.forEach(linkCell => {
            linkCell.stopCoinSpin();
        });
    }
}
